import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { MAJORS, CAREER_SLUGS } from "../mock/data";
import I18N from "../mock/i18n";
import { CompassSVG, BrandmarkSVG } from "./Compass";

export default function RunView() {
  const { shareId } = useParams();
  const [run, setRun] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.getRun(shareId).then(setRun).catch((e) => setErr(e.data?.detail || "Not found"));
  }, [shareId]);

  if (err) {
    return (
      <div className="App">
        <div className="topbar"><Link to="/" className="brandmark"><BrandmarkSVG /><span>Bearing</span></Link></div>
        <div className="wrap" style={{ padding: 80 }}><h2 style={{ color: "var(--parchment)" }}>Run not found</h2><p>This shared link is expired or invalid.</p></div>
      </div>
    );
  }
  if (!run) {
    return (
      <div className="App">
        <div className="topbar"><Link to="/" className="brandmark" style={{textDecoration:'none'}}><BrandmarkSVG /><span>Bearing</span></Link></div>
        <div className="wrap" style={{ padding: 80, color: "var(--white-soft)" }}>Loading shared bearing…</div>
      </div>
    );
  }

  const t = I18N[run.lang] || I18N.en;
  const balance = run.results_balance ?? 50;

  return (
    <div className="App" dir={t.dir}>
      <div className="topbar">
        <Link to="/" className="brandmark" style={{textDecoration:'none'}}><BrandmarkSVG /><span>{t.brand}</span></Link>
      </div>
      <div className="wrap">
        <div className="card">
          <div className="hintline" style={{margin:0, marginBottom:10}}>Shared bearing · read only</div>
          <h2>{t.resultsTitle}{run.profile?.name ? ` — ${run.profile.name}` : ""}</h2>
          <div className="sub">{t.resultsSubtitle}</div>
          <div className="compass-live">
            <CompassSVG balance={balance} wobble={run.diverges ? 26 : 0} leftLabel={t.familyWeightLeft} rightLabel={t.familyWeightRight} />
          </div>
        </div>

        {(run.top_majors || []).slice(0,5).map((tm, idx) => {
          const majorIdx = MAJORS.findIndex((m) => m.s === tm.slug);
          if (majorIdx < 0) return null;
          const m = MAJORS[majorIdx];
          const name = t.major[majorIdx];
          const pct = Math.round((tm.score || 0) * 100);
          return (
            <div key={tm.slug} className="resultcard">
              <div className="rank">{idx + 1}</div>
              <div className="headrow"><h3>{name}</h3><div className="matchpct">{pct}%</div></div>
              <div className="badgerow">
                <span className="badge">{t.outlookLabel}: {t.outlook[m.o]}</span>
              </div>
              <div className="careerlabel">{t.resultsCareersLabel}</div>
              <div className="careerchips">
                {m.c.map((cs) => {
                  const ci = CAREER_SLUGS.indexOf(cs);
                  return <span key={cs} className="careerchip">{t.career[ci]}</span>;
                })}
              </div>
            </div>
          );
        })}

        <div className="disclaimerbox">{t.resultsDisclaimer}</div>
        <div className="navrow" style={{margin:"24px 0 40px"}}>
          <span />
          <Link to="/" className="btn-primary" style={{textDecoration:'none'}}>Take my own bearing</Link>
        </div>
      </div>
    </div>
  );
}
